export enum IssueFeedTypeEnum {
  CHECKED = 'CHECKED',
  FIXED = 'FIXED',
  REPORTED = 'REPORTED',
  COMMENTED = 'COMMENTED',
}
